import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Card, Grid, Text } from '@aws-amplify/ui-react';

const HomePage = () => (
  <Grid templateColumns={{ base: '1fr', large: '1fr' }}>
    <Card>
      <Text>施設のホームページよりアクセスしてください。</Text>
      {process.env.REACT_APP_EnvironmentName === 'dev' && <Link to="/operation?facilityId=001">動作確認ページ</Link>}
    </Card>
  </Grid>
);

export default HomePage;
